export default __webpack_public_path__ + "assets/img/Submit_Form_Vec.4fabbcdb.svg";